import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7157d85c = () => interopDefault(import('../../../pages/close.vue' /* webpackChunkName: "pages/close" */))
const _b26353dc = () => interopDefault(import('../../../pages/comingsoon.vue' /* webpackChunkName: "pages/comingsoon" */))
const _e86a9fcc = () => interopDefault(import('../../../pages/confirm.vue' /* webpackChunkName: "pages/confirm" */))
const _35a40e4e = () => interopDefault(import('../../../pages/emailshare.vue' /* webpackChunkName: "pages/emailshare" */))
const _20eda26d = () => interopDefault(import('../../../pages/explore.vue' /* webpackChunkName: "pages/explore" */))
const _a9442ca6 = () => interopDefault(import('../../../pages/offers.vue' /* webpackChunkName: "pages/offers" */))
const _885f872e = () => interopDefault(import('../../../pages/request.vue' /* webpackChunkName: "pages/request" */))
const _99e35aaa = () => interopDefault(import('../../../pages/unsubscribe.vue' /* webpackChunkName: "pages/unsubscribe" */))
const _1f2d4f94 = () => interopDefault(import('../../../pages/win.vue' /* webpackChunkName: "pages/win" */))
const _98173ca8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/close",
    component: _7157d85c,
    name: "close___en-au___default"
  }, {
    path: "/en-au/close",
    component: _7157d85c,
    name: "close___en-au"
  }, {
    path: "/en-nz/close",
    component: _7157d85c,
    name: "close___en-nz"
  }, {
    path: "/en-gb/close",
    component: _7157d85c,
    name: "close___en-gb"
  }, {
    path: "/en-us/close",
    component: _7157d85c,
    name: "close___en-us"
  }, {
    path: "/en-ca/close",
    component: _7157d85c,
    name: "close___en-ca"
  }, {
    path: "/fr-fr/close",
    component: _7157d85c,
    name: "close___fr-fr"
  }, {
    path: "/comingsoon",
    component: _b26353dc,
    name: "comingsoon___en-au___default"
  }, {
    path: "/en-au/comingsoon",
    component: _b26353dc,
    name: "comingsoon___en-au"
  }, {
    path: "/en-nz/comingsoon",
    component: _b26353dc,
    name: "comingsoon___en-nz"
  }, {
    path: "/en-gb/comingsoon",
    component: _b26353dc,
    name: "comingsoon___en-gb"
  }, {
    path: "/en-us/comingsoon",
    component: _b26353dc,
    name: "comingsoon___en-us"
  }, {
    path: "/en-ca/comingsoon",
    component: _b26353dc,
    name: "comingsoon___en-ca"
  }, {
    path: "/fr-fr/comingsoon",
    component: _b26353dc,
    name: "comingsoon___fr-fr"
  }, {
    path: "/confirm",
    component: _e86a9fcc,
    name: "confirm___en-au___default"
  }, {
    path: "/en-au/confirm",
    component: _e86a9fcc,
    name: "confirm___en-au"
  }, {
    path: "/en-nz/confirm",
    component: _e86a9fcc,
    name: "confirm___en-nz"
  }, {
    path: "/en-gb/confirm",
    component: _e86a9fcc,
    name: "confirm___en-gb"
  }, {
    path: "/en-us/confirm",
    component: _e86a9fcc,
    name: "confirm___en-us"
  }, {
    path: "/en-ca/confirm",
    component: _e86a9fcc,
    name: "confirm___en-ca"
  }, {
    path: "/fr-fr/confirm",
    component: _e86a9fcc,
    name: "confirm___fr-fr"
  }, {
    path: "/emailshare",
    component: _35a40e4e,
    name: "emailshare___en-au___default"
  }, {
    path: "/en-au/emailshare",
    component: _35a40e4e,
    name: "emailshare___en-au"
  }, {
    path: "/en-nz/emailshare",
    component: _35a40e4e,
    name: "emailshare___en-nz"
  }, {
    path: "/en-gb/emailshare",
    component: _35a40e4e,
    name: "emailshare___en-gb"
  }, {
    path: "/en-us/emailshare",
    component: _35a40e4e,
    name: "emailshare___en-us"
  }, {
    path: "/en-ca/emailshare",
    component: _35a40e4e,
    name: "emailshare___en-ca"
  }, {
    path: "/fr-fr/emailshare",
    component: _35a40e4e,
    name: "emailshare___fr-fr"
  }, {
    path: "/explore",
    component: _20eda26d,
    name: "explore___en-au___default"
  }, {
    path: "/en-au/explore",
    component: _20eda26d,
    name: "explore___en-au"
  }, {
    path: "/en-nz/explore",
    component: _20eda26d,
    name: "explore___en-nz"
  }, {
    path: "/en-gb/explore",
    component: _20eda26d,
    name: "explore___en-gb"
  }, {
    path: "/en-us/explore",
    component: _20eda26d,
    name: "explore___en-us"
  }, {
    path: "/en-ca/explore",
    component: _20eda26d,
    name: "explore___en-ca"
  }, {
    path: "/fr-fr/explore",
    component: _20eda26d,
    name: "explore___fr-fr"
  }, {
    path: "/offers",
    component: _a9442ca6,
    name: "offers___en-au___default"
  }, {
    path: "/en-au/offers",
    component: _a9442ca6,
    name: "offers___en-au"
  }, {
    path: "/en-nz/offers",
    component: _a9442ca6,
    name: "offers___en-nz"
  }, {
    path: "/en-gb/offers",
    component: _a9442ca6,
    name: "offers___en-gb"
  }, {
    path: "/en-us/offers",
    component: _a9442ca6,
    name: "offers___en-us"
  }, {
    path: "/en-ca/offers",
    component: _a9442ca6,
    name: "offers___en-ca"
  }, {
    path: "/fr-fr/offers",
    component: _a9442ca6,
    name: "offers___fr-fr"
  }, {
    path: "/request",
    component: _885f872e,
    name: "request___en-au___default"
  }, {
    path: "/en-au/request",
    component: _885f872e,
    name: "request___en-au"
  }, {
    path: "/en-nz/request",
    component: _885f872e,
    name: "request___en-nz"
  }, {
    path: "/en-gb/request",
    component: _885f872e,
    name: "request___en-gb"
  }, {
    path: "/en-us/request",
    component: _885f872e,
    name: "request___en-us"
  }, {
    path: "/en-ca/request",
    component: _885f872e,
    name: "request___en-ca"
  }, {
    path: "/fr-fr/request",
    component: _885f872e,
    name: "request___fr-fr"
  }, {
    path: "/unsubscribe",
    component: _99e35aaa,
    name: "unsubscribe___en-au___default"
  }, {
    path: "/en-au/unsubscribe",
    component: _99e35aaa,
    name: "unsubscribe___en-au"
  }, {
    path: "/en-nz/unsubscribe",
    component: _99e35aaa,
    name: "unsubscribe___en-nz"
  }, {
    path: "/en-gb/unsubscribe",
    component: _99e35aaa,
    name: "unsubscribe___en-gb"
  }, {
    path: "/en-us/unsubscribe",
    component: _99e35aaa,
    name: "unsubscribe___en-us"
  }, {
    path: "/en-ca/unsubscribe",
    component: _99e35aaa,
    name: "unsubscribe___en-ca"
  }, {
    path: "/fr-fr/unsubscribe",
    component: _99e35aaa,
    name: "unsubscribe___fr-fr"
  }, {
    path: "/win",
    component: _1f2d4f94,
    name: "win___en-au___default"
  }, {
    path: "/en-au/win",
    component: _1f2d4f94,
    name: "win___en-au"
  }, {
    path: "/en-nz/win",
    component: _1f2d4f94,
    name: "win___en-nz"
  }, {
    path: "/en-gb/win",
    component: _1f2d4f94,
    name: "win___en-gb"
  }, {
    path: "/en-us/win",
    component: _1f2d4f94,
    name: "win___en-us"
  }, {
    path: "/en-ca/win",
    component: _1f2d4f94,
    name: "win___en-ca"
  }, {
    path: "/fr-fr/win",
    component: _1f2d4f94,
    name: "win___fr-fr"
  }, {
    path: "/",
    component: _98173ca8,
    name: "index___en-au___default"
  }, {
    path: "/en-au/",
    component: _98173ca8,
    name: "index___en-au"
  }, {
    path: "/en-nz/",
    component: _98173ca8,
    name: "index___en-nz"
  }, {
    path: "/en-gb/",
    component: _98173ca8,
    name: "index___en-gb"
  }, {
    path: "/en-us/",
    component: _98173ca8,
    name: "index___en-us"
  }, {
    path: "/en-ca/",
    component: _98173ca8,
    name: "index___en-ca"
  }, {
    path: "/fr-fr/",
    component: _98173ca8,
    name: "index___fr-fr"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
